module.exports = __webpack_public_path__ + "static/media/blue-red.76908f9b.png";